export default __webpack_public_path__ + "static/media/Goremonger's Boots.d1a0dd6d.jpg";